import { connect } from 'react-redux';
import type { Observable } from 'rxjs';
import type { ActivityFilter, DateFilter, PlatformFilter } from 'state/blotters/common/blotter.model';
import {
  secondaryMarketTradeBlotterAdvancedFiltersToggled,
  secondaryMarketTradeBlotterFilterChanged,
} from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.action';
import type { ITradeRequest } from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.selector';
import { isSecondaryMarketTradeBlotterLoading } from 'state/blotters/secondaryMarketTradeBlotter/secondaryMarketTradeBlotter.selector';
import { getSecondaryMarketTradeBlotterFilters, getSecondaryMarketTradeBlotterRequest } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type { SecondaryMarketPlatformFilter } from './Filter.helper';

export interface OwnProps {
  fetchCsv: (requestParams: ITradeRequest) => Observable<void>;
}

export interface StateProps {
  quickSearchTerm: string;
  dateFilter: DateFilter;
  activityFilter: ActivityFilter;
  platformFilter: SecondaryMarketPlatformFilter;
  advancedFilters: boolean;
  currencyFilter: string;
  requestParams: ITradeRequest;
  isLoading: boolean;
}

export interface DispatchProps {
  onQuickSearchTermChanged(quickSearchTerm?: string): void;

  onDateFilterChanged(value: DateFilter): void;

  onActivityFilterChanged(value: ActivityFilter): void;

  onPlatformFilterChanged(value: PlatformFilter): void;

  onAdvancedFilterToggled(): void;

  onCurrencyFilterChanged(value: string): void;
}

export const mapStateToProps = (state: AppState): StateProps => {
  const requestParams = getSecondaryMarketTradeBlotterRequest(state);
  const { quickSearchTerm, dateFilter, activityFilter, platformFilter, advancedFilters, currencyFilter } =
    getSecondaryMarketTradeBlotterFilters(state);
  const isLoading = isSecondaryMarketTradeBlotterLoading(state.blotters.secondaryMarket);

  return {
    quickSearchTerm,
    dateFilter,
    activityFilter,
    platformFilter,
    advancedFilters,
    currencyFilter,
    requestParams,
    isLoading,
  };
};

export const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  onQuickSearchTermChanged(quickSearch?: string) {
    dispatch(secondaryMarketTradeBlotterFilterChanged('quickSearchTerm', quickSearch ?? ''));
  },
  onDateFilterChanged(value) {
    dispatch(secondaryMarketTradeBlotterFilterChanged('dateFilter', value));
  },
  onActivityFilterChanged(value) {
    dispatch(secondaryMarketTradeBlotterFilterChanged('activityFilter', value));
  },
  onPlatformFilterChanged(value) {
    dispatch(secondaryMarketTradeBlotterFilterChanged('platformFilter', value as SecondaryMarketPlatformFilter));
  },
  onAdvancedFilterToggled() {
    dispatch(secondaryMarketTradeBlotterAdvancedFiltersToggled());
  },
  onCurrencyFilterChanged(value) {
    dispatch(secondaryMarketTradeBlotterFilterChanged('currencyFilter', value));
  },
});

export const connectFilterComponent = connect(mapStateToProps, mapDispatchToProps);
